module.exports = __webpack_public_path__ + "media/images/iconTrend--down-152ea83131d0ce2a36ae2f7379e15dbf.png";